const SIGMA = 5.67 * Math.pow(10, -8); // Stefan-Boltzmann constant
const TEMPDIFFERENCE = 0.5; // maximum allowed temperature difference between surface tempereature and calculated surface temperature
const KELVINCORRECTION = 273.15;
const LATENTHEATOFICE = 334;
const DENSITYOFICEATZERO = 920;
const GRAV = 9.80665;

const SOIL_LAMBDA = 2.0;
const CONCRETE_LAMBDA =	 1.4;

/** ***************************************************************************
******************************************************************************
******************************************************************************

##     ##    ###    ######## ########  #### ##     ##     ######     ###    ##        ######  ##     ## ##          ###    ######## ####  #######  ##    ##  ######
###   ###   ## ##      ##    ##     ##  ##   ##   ##     ##    ##   ## ##   ##       ##    ## ##     ## ##         ## ##      ##     ##  ##     ## ###   ## ##    ##
#### ####  ##   ##     ##    ##     ##  ##    ## ##      ##        ##   ##  ##       ##       ##     ## ##        ##   ##     ##     ##  ##     ## ####  ## ##
## ### ## ##     ##    ##    ########   ##     ###       ##       ##     ## ##       ##       ##     ## ##       ##     ##    ##     ##  ##     ## ## ## ##  ######
##     ## #########    ##    ##   ##    ##    ## ##      ##       ######### ##       ##       ##     ## ##       #########    ##     ##  ##     ## ##  ####       ##
##     ## ##     ##    ##    ##    ##   ##   ##   ##     ##    ## ##     ## ##       ##    ## ##     ## ##       ##     ##    ##     ##  ##     ## ##   ### ##    ##
##     ## ##     ##    ##    ##     ## #### ##     ##     ######  ##     ## ########  ######   #######  ######## ##     ##    ##    ####  #######  ##    ##  ######


******************************************************************************
******************************************************************************
*****************************************************************************/

function genMatrix(nrows, ncols) {
	let retMatrix = [];
	let i, j;
	let temp2;
	if (nrows != 0 && ncols != 0) {
		for (i = 0; i < nrows; i++) {
			temp2 = [];
			for (j = 0; j < ncols; j++) {
				temp2.push(0);
			}
			retMatrix.push(temp2);
		}
	}
	if (nrows == 1) {
		temp2 = [];
		for (j = 0; j < ncols; j++) {
			temp2.push(0);
		}
		retMatrix.push(temp2);
	}
	if (ncols == 1) {
		temp2 = [];
		for (j = 0; j < nrows; j++) {
			// temp2.push(0);
			retMatrix.push(0);
		}
	}
	return retMatrix;
}


//
// Transpose a GenMatrix
//
function transpose(m) {
	let i, j;
	let matrixrows = m.length;
	let matrixcols = m[0].length;
	let output = genMatrix(matrixcols, matrixrows);

	// output.setSize(matrixcols, matrixrows);
	if (matrixrows > 1) {
		for (i = 0; i < matrixrows; i++) {
			for (j = 0; j < matrixcols; j++) {
				output[j][i] = m[i][j];
			}
		}
	} else {
		for (i = 0; i < matrixrows; i++) {
			for (j = 0; j < matrixcols; j++) {
				output[j] = m[i][j];
			}
		}
	}
	return output;
}

//
// Create a square identity GenMatrix based on dimensions of this GenMatrix
//
function identity(m) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	let output = genMatrix(matrixcols, matrixrows);
	let i, j;
//			output.setSize(matrixcols, matrixrows);
	if (matrixrows == matrixcols) {
		for (i = 0; i < matrixrows; i++) {
			for (j = 0; j < matrixcols; j++) {
				if (i == j) {
					output[i][j] = 1;
				} else {
					output[i][j] = 0;
				}
			}
		}
	}
	return output;
}

//
//
// -------------------------------------------
// Add, Subtract, and Multiply a scalar by a GenMatrix
// -------------------------------------------
//
// Add a scalar to a GenMatrix
//
function scalarAdd(m, k) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	let output = genMatrix(matrixcols, matrixrows);
	let i, j;
//			output.setSize(matrixcols, matrixrows);
	for (i = 0; i  <  matrixrows; i++) {
		for (j = 0; j  <  matrixcols; j++) {
			output[i][j] = m[i][j] + k;
		}
	}
	return output;
}

//
// Subtract a scalar from a GenMatrix
//
function scalarSubtract(m, k) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	let output = genMatrix(matrixcols, matrixrows);
	let i, j;
//			output.setSize(matrixcols, matrixrows);
	for (i = 0; i  <  matrixrows; i++) {
		for (j = 0; j  <  matrixcols; j++) {
			output[i][j] = m[i][j] - k;
		}
	}
	return output;
}

//
// Multiply a GenMatrix by a scalar, k
//
function scalarMult(m, k) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	let output = genMatrix(matrixcols, matrixrows);
	let i, j;
//			output.setSize(matrixcols, matrixrows);
	for (i = 0; i  <  matrixrows; i++) {
		for (j = 0; j  <  matrixcols; j++) {
			output[i][j] = m[i][j] * k;
		}
	}
	return output;
}

// -------------------------------------------
// Add, Subtract, and Multiply two matrices
// -------------------------------------------
//
// Add two matrices together
//
function matrixAdd(m, matrixb) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	if ((matrixrows == matrixb.length) && (matrixcols == matrixb[0].length)) {
		var output = genMatrix(matrixrows, matrixcols);
		let i, j;
//				output.setSize(matrixrows, matrixcols);
		for (i = 0; i  <  matrixrows; i++) {
			for (j = 0; j  <  matrixcols; j++) {
				output[i][j] = m[i][j] + matrixb[i][j];
			}
		}
	}
	return output;
}

//
// Subtract two matrices
//   this.GenMatrix - GenMatrixb
//
function matrixSubtract(m, matrixb) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	if ((matrixrows == matrixb.length) && (matrixcols == matrixb[0].length)) {
		var output = genMatrix(matrixrows, matrixcols);
		let i, j;
//				output.setSize(matrixrows, matrixcols);
		for (i = 0; i  <  matrixrows; i++) {
			for (j = 0; j  <  matrixcols; j++) {
				output[i][j] = m[i][j] - matrixb[i][j];
			}
		}
	}
	return output;
}

//
// GenMatrix Multiplication
// Multiply two matrices | this GenMatrix is *post multiplied* by GenMatrixb
// so, A.GenMatrixMult(B) is equivalent to AB
//
function matrixMult(m, matrixb) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	if (matrixcols == matrixb[0].length) {
		var output = genMatrix(matrixrows, matrixb[0].length);
		let i, j, k;
		let sumproducts;
//				output.setSize(matrixrows, matrixb.matrixcols);

		for (i = 0; i  <  matrixrows; i++) {
			for (k = 0; k  <  matrixb[0].length; k++) {
				sumproducts = 0;
				for (j = 0; j  <  matrixb.length; j++) {
					if (matrixcols == 1) {
						sumproducts = sumproducts + (m[i] * matrixb[j][k]);
					}
					if (matrixb[0].length == 1) {
						sumproducts = sumproducts + (m[i][j] * matrixb[j]);
					}
					if ((matrixcols != 1) && (matrixb[0].length != 1)) {
						sumproducts = sumproducts + (m[i][j] * matrixb[j][k]);
					}
				}
				if (matrixrows == 1) {
					output[i] = sumproducts;
				} else {
					output[i][k] = sumproducts;
				}
			}
		}
	}
	return output;
}

//
// GenMatrix * Vector Multiplication
// Post-multiply a GenMatrix by a vector
// so, A.GenMatrixVectorMult(v) is equivalent to Av
//
function matrixVectorMult(m, vector) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	let k, j;
	let sumproducts;
	let kk = vector.length;
	let output = [];
		for (k = 0; k  <  matrixcols; k++) {
			sumproducts = 0;
			for (j = 0; j  <  kk; j++) {
				sumproducts = sumproducts + (m[k][j] * vector[j]);
			}
			output[k] = sumproducts;
		}
	return output;
}

// Estimate the inverse and determinant of a square GenMatrix
//
// based on the pivot method as explained by
// Carroll, Green, & Chaturvedi (1997). Mathematical tools for applied multivariate
// analysis.  San Diego: Academic Press. (pp. 66 - 68; 184-187)
//
// I didn't spend the time to make this code efficient or polished.
// It does work, however!  The GenMatrix in question cannot have a
// 0 in the leading entry.
//
export function inverse(m) {
	let matrixrows = m.length;
	let matrixcols = m[0].length;

	let i, j, k, jj, t;
	let temp = [];
	let AIS = [];
	let temp1 = [];
	let multiplier;
	let trow2;
	let temp2;
	let endvec = [];
	let targetRow;
	let tmp;

	// find dimensions of GenMatrix
	let A = m;
	let B;

	k = A.length;
	let pivots = [];
	for(t = 0; t < k; t++) { pivots[t] = 0; }
	//
	// Concatenate this GenMatrix with an identity GenMatrix of same dimensions.
	// This new GenMatrix will be called AI.
	B = identity(A);
	let AI = genMatrix(k, (k * 2));
//			AI.setSize(k, (k * 2));

	for (i = 0; i  <  k; i++) {
		temp = A[i].concat(B[i]);
		for (j = 0; j  <  (k * 2); j++) {
			AI[i][j] = temp[j];
		}
	}

	// Copy AI k times.  The different copies will be used to save
	// the operations at different points in the pivot process
	// AI0 will contain the original version of AI
	var AInull = genMatrix(k, (k * 2));
//			AInull.setSize(k, (k * 2));
	for (i = 1; i  <  (k + 1); i++) {
		tmp = genMatrix(k, (k * 2));
//				tmp.setSize(k, (k * 2));
		AIS[i] = tmp;
	}
	AIS[0] = AI;
	//
	// Loop through each pivoting level
	//
	for (i = 0; i  <  (k - 1); i++) {
		// select pivot
		let pivot = AIS[i][i][i];
		pivots[i] = pivot;

		// get target row from original GenMatrix
		targetRow = [];
		for (jj = 0; jj  <  (k * 2); jj++) {
			targetRow[jj] = AIS[i][i][jj];
		}

		// divide this row by pivot to create targetRow
		for (jj = 0; jj  <  (k * 2); jj++) {
			targetRow[jj] = targetRow[jj] / pivot;
		}
		// assign target row to next GenMatrix
		AIS[(i + 1)][i] = targetRow;
		//
		// Loop through remaing rows of this GenMatrix level and
		// perform row operations
		for (j = (i + 1); j  <  k; j++) {
			for(t = 0; t < k * 2; t++) { temp1[t] = 0; }
			// select multiplier (first non-zero element of next row of previous GenMatrix)
			multiplier = AIS[i][j][i];
			// multiply multiplier by targetRow
			for (jj = 0; jj  <  (k * 2); jj++) {
				temp1[jj] = targetRow[jj] * multiplier;
			}
			// fill in counterpart
			trow2 = [];
			for (jj = 0; jj  <  (k * 2); jj++) {
				trow2[jj] = AIS[i][j][jj];
			}
			temp2 = new Array(k * 2);
			// subtract temp1 from counterpart row
			for (jj = 0; jj  <  (k * 2); jj++) {
				temp2[jj] = trow2[jj] - temp1[jj];
			}
			// fill in counterpart
			AIS[(i + 1)][j] = temp2;
		}
		// end j
	}
	// end i
	//
	// complete the last pivot
	pivots[(k - 1)] = AIS[(k - 1)][(k - 1)][(k - 1)];
	// Compute the determinant of the GenMatrix as the product of the pivots
	let det = 1;
	for (jj = 0; jj  <  k; jj++) {
		det = det * pivots[jj];
	}
	//
	// Use backsubstitution to solve for the inverse
	// result will be saved in GenMatrix "inverse"
	//
	let inverse = genMatrix(k, k);
//			inverse.setSize(k, k);
	let inverseCol = 0;
	// find first row of backwards inverse GenMatrix
	targetRow = [];
	for (jj = 0; jj  <  (k * 2); jj++) {
		targetRow[jj] = AIS[(k - 1)][k - 1][jj];
	}
	// divide targetRow by pivots[k]
	for (jj = 0; jj  <  (k * 2); jj++) {
		targetRow[jj] = targetRow[jj] / pivots[k - 1];
	}
	// insert targetRow into AI level k+1
	for (jj = 0; jj  <  (k * 2); jj++) {
		AIS[k][0][jj] = targetRow[jj];
	}
	// loop through each column of the final GenMatrix
	//
	for (j = k; j  <  (k + k - 0); j++) {
		for(t = 0; t < k - 1; t++) { endvec[t] = 0; }

		// fill endvec with zeros
		for (jj = 0; jj  <  (k - 1); jj++) {
			endvec[jj] = 0;
		}
		// allow the last element of endvec to equal last piece
		endvec[k - 1] = AIS[k][0][j];
		//
		// loop thru and calculate inverse within each column
		for (i = (k - 2); i >= 0; i--) {
			// pull out row i from AI level i+1
			temp = [];
			temp = AIS[(i + 1)][i];
			// multiply each element of that row by each element of endvec. sum products
			let tempsum = 0;
			for (jj = 0; jj  <  k; jj++) {
				tempsum = tempsum + AIS[(i + 1)][i][jj] * endvec[jj];
			}
			// subject tempsum from temp
			endvec[i] = AIS[(i + 1)][i][j] - tempsum;
		}
		// save result to correct part of inverse GenMatrix
		for (jj = 0; jj  <  k; jj++) {
			inverse[jj][inverseCol] = endvec[jj];
		}
		inverseCol = inverseCol + 1;
	}
	// end j
	// //////////////trace("determinant = "+det);
	return inverse;
}


/** ***************************************************************************
******************************************************************************
******************************************************************************


######## ##     ## ######## ########  ##     ##    ###    ##          ######## ##     ## ##    ##  ######  ######## ####  #######  ##    ##  ######
   ##    ##     ## ##       ##     ## ###   ###   ## ##   ##          ##       ##     ## ###   ## ##    ##    ##     ##  ##     ## ###   ## ##    ##
   ##    ##     ## ##       ##     ## #### ####  ##   ##  ##          ##       ##     ## ####  ## ##          ##     ##  ##     ## ####  ## ##
   ##    ######### ######   ########  ## ### ## ##     ## ##          ######   ##     ## ## ## ## ##          ##     ##  ##     ## ## ## ##  ######
   ##    ##     ## ##       ##   ##   ##     ## ######### ##          ##       ##     ## ##  #### ##          ##     ##  ##     ## ##  ####       ##
   ##    ##     ## ##       ##    ##  ##     ## ##     ## ##          ##       ##     ## ##   ### ##    ##    ##     ##  ##     ## ##   ### ##    ##
   ##    ##     ## ######## ##     ## ##     ## ##     ## ########    ##        #######  ##    ##  ######     ##    ####  #######  ##    ##  ######


******************************************************************************
******************************************************************************
*****************************************************************************/


/*


##     ##  ######  ##     ##    ########  ##          ###    #### ##    ##
##     ## ##    ## ##     ##    ##     ## ##         ## ##    ##  ###   ##
##     ## ##       ##     ##    ##     ## ##        ##   ##   ##  ####  ##
######### ##       ##     ##    ########  ##       ##     ##  ##  ## ## ##
##     ## ##        ##   ##     ##        ##       #########  ##  ##  ####
##     ## ##    ##   ## ##      ##        ##       ##     ##  ##  ##   ###
##     ##  ######     ###       ##        ######## ##     ## #### ##    ##


 */
function calcHcvFlatSurface({surfaceTemp, ambientTemp, airV = 0, target,  }) {
	let charactL;
	let Nusselt;
	const boundaryTemp = (surfaceTemp + ambientTemp) / 2;
	const tempDiff = Math.abs(surfaceTemp - ambientTemp);
	const boundaryTempK = boundaryTemp + KELVINCORRECTION;
	const boundaryLambda = 0.0243 + 7.8421 * Math.pow(10, -5) * boundaryTemp - 2.0755 * Math.pow(10, -8) * Math.pow(boundaryTemp, 2);
	const kinematicVisc = ( 4.2113 * Math.pow(10, -9) * Math.pow(boundaryTempK, 2.5) ) / ( 112 + boundaryTempK );

	!( target && target.noLog) && console.log('--------------------');
	!( target && target.noLog) && console.log(' in hcv plane loop');
	!( target && target.noLog) && target.rectSurface && console.log(' ' + target.rectSurface);

	!( target && target.noLog) && console.log({surfaceTemp, ambientTemp, airV, target});
	!( target && target.noLog) && console.log({boundaryTemp, tempDiff, boundaryLambda, kinematicVisc, });

	if(airV === 0) {
		if(target.direction === 'vert') {
			if(target.shape === 'square') {
				charactL = target.height;
			} else {
				charactL = Math.PI * (target.length / 2) / 2;
				// charactL = Math.PI * Math.pow((target.length / 2),2) / Math.PI/ target.length
			}
		} else {
			if(target.shape === 'square') {
				charactL = (target.length * target.width) / ( 2 * (target.length + target.width) );
			} else {
				charactL = (Math.PI * Math.pow((target.length / 2), 2)) / (Math.PI * target.length);
			}
		}
		let Grashof = (GRAV * Math.pow(charactL, 3) * tempDiff) / (Math.pow(kinematicVisc, 2) * boundaryTempK);
		!(target && target.noLog) &&
		console.log('Grashof = ( GRAV * Math.pow(charactL, 3) * tempDiff ) / ( Math.pow(kinematicVisc, 2) * boundaryTempK )');

		if (target.direction === 'vert') {
			if (Grashof > 1400000000000) {
				Grashof = 1400000000000;
			}
			!(target && target.noLog) && console.log('Nusselt = Math.pow( ( 0.825 + 0.3063 * Math.pow(Grashof, (1/6)) ) ,2)');
			Nusselt = Math.pow( ( 0.825 + 0.3063 * Math.pow(Grashof, (1 / 6)) ), 2);
		} else {
			if ((surfaceTemp > ambientTemp && target.position === 'bottom') || (surfaceTemp < ambientTemp && target.position === 'top')) {
				if (Grashof < 4000) {
					Grashof = 4000;
				}
				if (Grashof > 40000000000) {
					Grashof = 40000000000;
				}

				!(target && target.noLog) && console.log('Nusselt = 0.453 * Math.pow(Grashof, (1/5))');
				Nusselt = 0.453 * Math.pow(Grashof, (1 / 5));
			} else {
				if (Grashof <= (2.4 * Math.pow(10, 5))) {
					!(target && target.noLog) && console.log('Nusselt = 0.593 * Math.pow(Grashof, (1/5))');
					Nusselt = 0.593 * Math.pow(Grashof, (1 / 5));
				} else {
					!(target && target.noLog) && console.log('Nusselt = 0.0988 * Math.pow(Grashof, (1/3))');
					Nusselt = 0.0988 * Math.pow(Grashof, (1 / 3));
				}
			}
		}

		!( target && target.noLog) && console.log({charactL, Grashof, Nusselt});
	} else {
		if(target.direction === 'vert') {
			if(target.shape === 'square') {
				charactL = target.width;
			} else {
				charactL = Math.PI * (target.length / 2) / 2;
				// charactL = Math.PI * Math.pow((target.length / 2),2) / Math.PI/ target.length
			}
		} else {
			if(target.shape === 'square') {
				charactL = (target.length + target.width) / 2;
				// charactL = (target.length * target.width) / ( 2 * (target.length + target.width) )
			} else {
				// charactL = (Math.PI * Math.pow((target.length / 2),2)) / (Math.PI * target.length)
				const diam = target.length;
				charactL = 2 * Math.sqrt( ( Math.pow( (diam / 2), 2 ) - Math.pow( (diam / 4), 2 ) ) );
			}
		}

		// if(target.shape === 'square') {
		// 	charactL = target.width
		// } else {
		// 	charactL = Math.PI * (target.length / 2) /2
		// }

		!(target && target.noLog) && console.log('Reynolds = ( airV * charactL ) / kinematicVisc');
		!(target && target.noLog) && console.log('NusseltLaminar = 0.592 * Math.pow(Reynolds, (1/2))');
		!(target && target.noLog) &&
      console.log('NusseltTurbulent = ( 0.0262 * Math.pow(Reynolds, 0.8) ) / ( 1 - ( 0.5 / Math.pow(Reynolds, 0.1) ) )');
		!(target && target.noLog) && console.log('Nusselt = Math.sqrt( Math.pow(NusseltLaminar, 2) + Math.pow(NusseltTurbulent, 2) )');

		const Reynolds = ( airV * charactL ) / kinematicVisc;
		const NusseltLaminar = 0.592 * Math.pow(Reynolds, (1 / 2));
		const NusseltTurbulent = ( 0.0262 * Math.pow(Reynolds, 0.8) ) / ( 1 - ( 0.5 / Math.pow(Reynolds, 0.1) ) );

		Nusselt = Math.sqrt( Math.pow(NusseltLaminar, 2) + Math.pow(NusseltTurbulent, 2) );

		!( target && target.noLog) && console.log({charactL, Reynolds, NusseltLaminar, NusseltTurbulent, Nusselt});
	}

	return ( (Nusselt * boundaryLambda) / charactL );
}

/*

##     ##  ######  ##     ##    ########  #### ########  ########
##     ## ##    ## ##     ##    ##     ##  ##  ##     ## ##
##     ## ##       ##     ##    ##     ##  ##  ##     ## ##
######### ##       ##     ##    ########   ##  ########  ######
##     ## ##        ##   ##     ##         ##  ##        ##
##     ## ##    ##   ## ##      ##         ##  ##        ##
##     ##  ######     ###       ##        #### ##        ########


 */
function calcHcvPipe({surfaceTemp, ambientTemp, airV = 0, target,  }) {
	!( target && target.noLog) && console.log('--------------------');
	!( target && target.noLog) && console.log(' in hcv pipe loop');
	!( target && target.noLog) && console.log({surfaceTemp, ambientTemp, airV, target});

	let charactL = Math.PI * target.diameter / 2;
	const boundaryTemp = (surfaceTemp + ambientTemp) / 2;
	const tempDiff = Math.abs(surfaceTemp - ambientTemp);
	const boundaryTempK = boundaryTemp + KELVINCORRECTION;
	const boundaryLambda = 0.0243 + 7.8421 * Math.pow(10, -5) * boundaryTemp - 2.0755 * Math.pow(10, -8) * Math.pow(boundaryTemp, 2);
	const kinematicVisc = ( 4.2113 * Math.pow(10, -9) * Math.pow(boundaryTempK, 2.5) ) / ( 112 + boundaryTempK );
	let Nusselt;

	!( target && target.noLog) && console.log({boundaryTemp, boundaryTempK, tempDiff, boundaryLambda, kinematicVisc, });

	if (airV === 0) {
		if (target.direction !== 'hor') {
			charactL = target.length;
		}

		let Grashof = (GRAV * Math.pow(charactL, 3) * tempDiff) / (Math.pow(kinematicVisc, 2) * boundaryTempK);
		if (Grashof > 1400000000000) {
			Grashof = 1400000000000;
		}

	!(target && target.noLog) &&
    console.log('Grashof = ( GRAV * Math.pow(charactL, 3) * tempDiff ) / ( Math.pow(kinematicVisc, 2) * boundaryTempK )');

		if (target.direction === 'hor') {
				!(target && target.noLog) && console.log('Nusselt = Math.pow( ( 0.752 + 0.303 * Math.pow(Grashof, (1/6)) ) ,2)');
			Nusselt = Math.pow( ( 0.752 + 0.303 * Math.pow(Grashof, (1 / 6)) ), 2);
		} else {
				!(target && target.noLog) &&
          console.log('Nusselt = Math.pow( ( 0.825 + 0.306 * Math.pow(Grashof, (1/6)) ) ,2) + 0.87 * ( charactL / target.diameter )');
			Nusselt = Math.pow( ( 0.825 + 0.306 * Math.pow(Grashof, (1 / 6)) ), 2) + 0.87 * ( charactL / target.diameter );
		}

		!( target && target.noLog) && console.log({charactL, Grashof, Nusselt, });
	} else {
		!(target && target.noLog) && console.log('Reynolds = ( airV * charactL ) / kinematicVisc');
		!(target && target.noLog) && console.log('NusseltLaminar = 0.592 * Math.pow(Reynolds, (1/2))');
		!(target && target.noLog) &&
      console.log('NusseltTurbulent = ( 0.0262 * Math.pow(Reynolds, 0.8) ) / ( 1 - ( 0.5 / Math.pow(Reynolds, 0.1) ) )');
		!(target && target.noLog) && console.log('Nusselt = 0.3 + Math.sqrt( Math.pow(NusseltLaminar, 2) + Math.pow(NusseltTurbulent, 2) )');
		const Reynolds = ( airV * charactL ) / kinematicVisc;
		const NusseltLaminar = 0.592 * Math.pow(Reynolds, (1 / 2));
		const NusseltTurbulent = ( 0.0262 * Math.pow(Reynolds, 0.8) ) / ( 1 - ( 0.5 / Math.pow(Reynolds, 0.1) ) );

		Nusselt = 0.3 + Math.sqrt( Math.pow(NusseltLaminar, 2) + Math.pow(NusseltTurbulent, 2) );

		!( target && target.noLog) && console.log({charactL, Reynolds, NusseltLaminar, NusseltTurbulent, Nusselt});
	}

	return ( (Nusselt * boundaryLambda) / charactL );
}

/*


##     ##  ######  ####
##     ## ##    ##  ##
##     ## ##        ##
#########  ######   ##
##     ##       ##  ##
##     ## ##    ##  ##
##     ##  ######  ####


 */
function calcHsi({surfaceTemp, ambientTemp, airV, target,  }) {
	!( target && target.noLog) && console.log('--------------------');
	!( target && target.noLog) && console.log(' in hsi loop');

	const viscosity =  (4.2113 * Math.pow(10, -9) * Math.pow( (target.innerTemp + KELVINCORRECTION), 2.5 ) ) / (112 + target.innerTemp + KELVINCORRECTION);
	const density = 348.35 / (target.innerTemp + KELVINCORRECTION);
	// const lambda = 0.0243 + 7.8421 * Math.pow(10,-5) * target.innerTemp - 2.0755 * Math.pow(10,-8) * Math.pow(target.innerTemp,2)

	let Nusselt;
	let charactL;
	let Prandtl;
	let Reynolds;
	if(target.model === 'circular') {
		charactL = target.insideDiameter;

		Prandtl = 0.709; // (density * viscosity * target.heatCapasity *1000) / target.lambda
		Reynolds = (target.flowRate * charactL) / viscosity;
		!(target && target.noLog) && console.log(' Prandtl = (density * viscosity * target.heatCapasity *1000) / target.lambda');
		!(target && target.noLog) && console.log('         = (' + density + ' * ' + viscosity + ' * ' + target.heatCapasity + ' *1000) / ' + target.lambda);
		!(target && target.noLog) && console.log(' Reynolds = (target.flowRate * charactL) / viscosity');
		!(target && target.noLog) && console.log('          = (' + target.flowRate + ' * ' + charactL + ') / ' + viscosity);

		if( Prandtl <= 1.5) {
			Nusselt = 0.0214 * ( Math.pow(Reynolds, 0.8) - 100 ) * Math.pow(Prandtl, 0.4);
			!(target && target.noLog) && console.log(' Nusselt = 0.0214 * ( Math.pow(Reynolds,0.8) - 100 ) * Math.pow(Prandtl,0.4)');
			!(target && target.noLog) && console.log('         = 0.0214 * ( ' + Math.pow(Reynolds, 0.8) + ' - 100 ) * ' + Math.pow(Prandtl, 0.4));
		} else {
			Nusselt = 0.012 * ( Math.pow(Reynolds, 0.87) - 280 ) * Math.pow(Prandtl, 0.4);
			!(target && target.noLog) && console.log(' Nusselt = 0.012 * ( Math.pow(Reynolds,0.87) - 280 ) * Math.pow(Prandtl,0.4)');
			!(target && target.noLog) && console.log('         = 0.012 * ( ' + Math.pow(Reynolds, 0.87) + ' - 280 ) * ' + Math.pow(Prandtl, 0.4));
		}
	} else {
		charactL = (4 * target.height * target.width) / (2 * target.height + 2 * target.width);
		Prandtl = 0.709; // (density * viscosity * target.heatCapasity *1000) / target.lambda
		Reynolds = (target.flowRate * charactL) / viscosity;
		!(target && target.noLog) && console.log(' Prandtl = (density * viscosity * target.heatCapasity *1000) / target.lambda');
		!(target && target.noLog) && console.log('         = (' + density + ' * ' + viscosity + ' * ' + target.heatCapasity + ' *1000) / ' + target.lambda);
		!(target && target.noLog) && console.log(' Reynolds = (target.flowRate * charactL) / viscosity');
		!(target && target.noLog) && console.log('          = (' + target.flowRate + ' * ' + charactL + ') / ' + viscosity);

		const xi = Math.pow( ((1.8 * Math.log10(Reynolds)) - 1.5), -2 );
		Nusselt = ( ( xi / 8) * Reynolds * Prandtl ) / ( 1 + 12.7 * Math.sqrt((xi / 8)) * ( Math.pow(Prandtl, (2 / 3)) - 1 ) );
		!(target && target.noLog) && console.log(' xi = Math.pow( ((1.8 * Math.log10(Reynolds)) -1.5) ,-2 )');
		!(target && target.noLog) && console.log(' xi = ' + xi);
		!(target && target.noLog) && console.log(' Nusselt = ( ( xi/8) * Reynolds * Prandtl ) / ( 1 + 12.7 * Math.sqrt((xi/8)) * ( Math.pow(Prandtl, (2/3)) -1 ) )');
		!(target && target.noLog) && console.log('         = ( ( ' + (xi / 8) + ') * ' + Reynolds + ' * ' + Prandtl + ' ) / ( 1 + 12.7 * ' + Math.sqrt((xi / 8)) + ' * ( ' + Math.pow(Prandtl, (2 / 3)) + ' -1 ) )');
	}

	!( target && target.noLog) && console.log({charactL, Reynolds, Prandtl, Nusselt, targetLambda: target.lambda});

	if(Reynolds <= 2300 || Prandtl <= 0.5 || Prandtl >= 500 ) return 0;

	return ( (Nusselt * target.lambda) / charactL );
}

/*


##     ##  ######  ##     ##
##     ## ##    ## ##     ##
##     ## ##       ##     ##
######### ##       ##     ##
##     ## ##        ##   ##
##     ## ##    ##   ## ##
##     ##  ######     ###


 */
function hcv({surfaceTemp, ambientTemp, airV = 0, target,  }) {
	if(!( target && target.noLog)) {
		console.log('----------------------------------------------');
		console.log(' calculating ', target.actualType);
		console.log(' round ', target.roundIndex);
		if(target && target.uninsulated) {
			console.log(' Object is uninsulated');
		}
	}

	if(target.type === 'pipe') {
		return calcHcvPipe({surfaceTemp, ambientTemp, airV, target,  });
	} else if(target.type === 'plane') {
		return calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target,  });
	} else {
		let hsi = 0;
		if (target.content === 'Air' && target.insideTemp >= -50 && target.insideTemp <= 100 && target.length > 0 && target.flowRate > 0) {
			hsi = calcHsi({surfaceTemp, ambientTemp, airV, target,  });
		}
		let hcv;

		if(target.model === 'circular') {
			hcv = calcHcvPipe({surfaceTemp, ambientTemp, airV, target,  });
		} else {
			if (target.direction === 'vert') {
				const targetH = target.noIns ? target.height : target.height + target.insThickness * 2;
				const targetW = target.noIns ? target.width : target.width + target.insThickness * 2;
				const average = (targetH + targetW) / 2;

				if (airV === 0) {
					hcv = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target: {...target, shape: 'square', height: target.length},  });
				} else {
					hcv = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target: {...target, shape: 'square', width: average  },  });
				}
			} else {
				const targetH = target.noIns ? target.height : target.height + target.insThickness * 2;
				const targetW = target.noIns ? target.width : target.width + target.insThickness * 2;
				const targetL = target.length;
				// const targetL = (targetH+targetW)/2
				// const hcvSide = calcHcvFlatSurface({ surfaceTemp, ambientTemp, airV, target: { ...target, direction: 'vert', shape: 'square', rectSurface:'rect duct, side' }, })
				const hcvSide = calcHcvFlatSurface({ surfaceTemp, ambientTemp, airV, target: { ...target, width: target.length, height: targetH, direction: 'vert', shape: 'square', rectSurface: 'rect duct, side' }, });
				let hcvTop;
				let hcvBot;
				if (airV === 0) {
					// hcvTop = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target:{...target, shape:'square', position:'top', width:targetW, rectSurface:'rect duct, top' },  })
					// hcvBot = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target:{...target, shape:'square', position:'bottom', width:targetW, height:targetH, rectSurface:'rect duct, bottom' },  })
					hcvTop = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target: {...target, shape: 'square', position: 'top', width: targetW, height: target.length, rectSurface: 'rect duct, top' },  });
					hcvBot = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target: {...target, shape: 'square', position: 'bottom', width: targetW, height: target.length, rectSurface: 'rect duct, bottom' },  });
				} else {
					// hcvTop = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target:{...target, shape:'square', position:'top', width:target.length, rectSurface:'rect duct, top' },  })
					// hcvBot = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target:{...target, shape:'square', position:'bottom', width:target.length, height:targetH, rectSurface:'rect duct, bottom' },  })
					hcvTop = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target: {...target, shape: 'square', position: 'top', width: target.length, height: targetW, rectSurface: 'rect duct, top' },  });
					hcvBot = calcHcvFlatSurface({surfaceTemp, ambientTemp, airV, target: {...target, shape: 'square', position: 'bottom', width: target.length, height: targetW, rectSurface: 'rect duct, bottom' },  });
				}

				const round = 2 * targetH + 2 * targetW;
				hcv = (targetH / round * hcvSide + targetW / round * hcvTop + targetH / round * hcvSide + targetW / round * hcvBot );

				!( target && target.noLog) && console.log('------------------------');
				!( target && target.noLog) && console.log(' rectangular duct ');
				!( target && target.noLog) && console.log({hcv});
				!( target && target.noLog) && console.log({hcvSide, hcvTop, hcvBot});
			}
		}

		!( target && target.noLog) && console.log({hsi, hcv});

		return (hcv);
	}
}

/*


   ###    ##       ########  ##     ##    ###       ########
  ## ##   ##       ##     ## ##     ##   ## ##      ##
 ##   ##  ##       ##     ## ##     ##  ##   ##     ##
##     ## ##       ########  ######### ##     ##    ######
######### ##       ##        ##     ## #########    ##
##     ## ##       ##        ##     ## ##     ##    ##
##     ## ######## ##        ##     ## ##     ##    ########


 */
function alphaE( type,  epsilon,  outerTemp,  surfaceTemp,  outerDiam = -1,  airV = 0, target = null) {
	var tmpValR = 0;
	var tmpValK;
	if (epsilon > 0 ) tmpValR = alphaR(epsilon, outerTemp, surfaceTemp); // hr
	if(target) {
		tmpValK = hcv( {surfaceTemp: (surfaceTemp - KELVINCORRECTION), ambientTemp: (outerTemp - KELVINCORRECTION), airV, target });
		// console.log({hcv:tmpValK, hr: tmpValR})
	} else {
		tmpValK = alphaK(type, outerTemp, surfaceTemp, outerDiam, airV);
	}
	 // console.log('alphaR: ',tmpValR,'| alphaK: ',tmpValK, ' | alphaE: ',(tmpValR + tmpValK));
	return ( tmpValR + tmpValK );
}


/*


   ###    ##       ########  ##     ##    ###       ########
  ## ##   ##       ##     ## ##     ##   ## ##      ##     ##
 ##   ##  ##       ##     ## ##     ##  ##   ##     ##     ##
##     ## ##       ########  ######### ##     ##    ########
######### ##       ##        ##     ## #########    ##   ##
##     ## ##       ##        ##     ## ##     ##    ##    ##
##     ## ######## ##        ##     ## ##     ##    ##     ##

 */
function alphaR( epsilon,  outerTemp,  surfaceTemp) {
	if (outerTemp == surfaceTemp) return (epsilon * SIGMA);

	var tmpVal1 = Math.pow(surfaceTemp, 4) - Math.pow(outerTemp, 4);
	var tmpVal2 = surfaceTemp - outerTemp;

	return (epsilon * SIGMA * tmpVal1 / tmpVal2);
}

/*


   ###    ##       ########  ##     ##    ###       ##    ##
  ## ##   ##       ##     ## ##     ##   ## ##      ##   ##
 ##   ##  ##       ##     ## ##     ##  ##   ##     ##  ##
##     ## ##       ########  ######### ##     ##    #####
######### ##       ##        ##     ## #########    ##  ##
##     ## ##       ##        ##     ## ##     ##    ##   ##
##     ## ######## ##        ##     ## ##     ##    ##    ##


 */
function alphaK( type,  outerTemp,  surfaceTemp,  outerDiam,  airV) {
	var retVal;
	var sign = 1;
	if (type == 'pipe') {
		/* if ( (airV * outerDiam) < 0.00855 ) {
			retVal = 0.0081 / (outerDiam / 1000) + 3.14 * Math.sqrt( (airV/outerDiam) );
		} else {
			retVal = 2 * airV +3 * Math.sqrt( (airV / outerDiam));
		}*/
		if (surfaceTemp < outerTemp) {
			sign = -1;
		}
		if (airV != 0) {
			retVal = 8.9 * Math.pow(airV, 0.9) / Math.pow(outerDiam, 0.1);
			// console.log('retval: ',retVal);
			// console.log('SFS: ',(4.13 * Math.pow(airV, 0.8) / Math.pow(outerDiam, 0.2)))
			// console.log('Ger: ',( 8.1/(outerDiam*1000) + 3.14* Math.sqrt(airV/outerDiam) ));
			// console.log('Ger2: ',( 2*airV + 3* Math.sqrt(airV/outerDiam) ));
		} else {
			if (outerTemp == surfaceTemp) return 0;
			retVal = 1.32 * Math.pow( ( Math.abs(surfaceTemp - outerTemp) / outerDiam ), 0.25);
			// console.log('no speed:', retVal);
		}
	} else {
		if (airV > 5) {
			retVal = 7.6 * Math.pow(airV, 0.8);
		} else {
			if(airV != 0) {
				retVal = 6.2 + 4.2 * airV;
			} else {
				if (outerTemp == surfaceTemp) return 0;
				if ( Math.abs(surfaceTemp - outerTemp) > 10) {
					retVal = 2.55 * Math.pow( Math.abs(surfaceTemp - outerTemp), 0.25);
				} else {
					retVal = 3.5 + 0.09 * Math.abs(surfaceTemp - outerTemp);
				}
			}
		}
	}
	return retVal;
}

// lamdaArr must be an array with thermal conductivity values a0, a1, a2 and a3
export function getLambdaVal( medianTemp,  lambdaArr, additionToLambda = 0, jointMultiplier = 1 ) {
	let tmpArr = [];

	var retVal = lambdaArr[0] + lambdaArr[1] * medianTemp + lambdaArr[2] * Math.pow(medianTemp, 2) + lambdaArr[3] * Math.pow(medianTemp, 3);
	// var retVal = lambdaArr[0] + lambdaArr[1] * medianTemp + lambdaArr[2] * Math.pow(medianTemp, 2) //+ lambdaArr[3] * Math.pow(medianTemp, 3);

	return ((retVal * jointMultiplier) + additionToLambda);
}

/*


##     ## ########    ###    ######## ##        #######   ######   ######
##     ## ##         ## ##      ##    ##       ##     ## ##    ## ##    ##
##     ## ##        ##   ##     ##    ##       ##     ## ##       ##
######### ######   ##     ##    ##    ##       ##     ##  ######   ######
##     ## ##       #########    ##    ##       ##     ##       ##       ##
##     ## ##       ##     ##    ##    ##       ##     ## ##    ## ##    ##
##     ## ######## ##     ##    ##    ########  #######   ######   ######

 */
// heatLoss(type, innerTemp + KELVINCORRECTION, outerTemp + KELVINCORRECTION, calcLambda, calcAlphaE, insulThick, innerDiam, outerDiam)
export function heatLoss( type,  innerTemp,  outerTemp,  lambda,  alpha,  insulThick,  innerDiam,  outerDiam, hsi, target) {
	var phi;
	var arrLength;
	var tmpVal;
	var i;

	// const solarAffect = (target.solarRadiation)
	// 	? target.solarRadiationValue / alpha
	// 	: 0

	// // const solarAffect = 0
	// console.log('-------------------------------')
	// console.log(' Solar radiation values')
	// console.log({solarValue:target.solarRadiationValue, hse:alpha, solarAffect})
	if (type == 'pipe') {
		if (innerDiam.length > 1) {
			arrLength = innerDiam.length;
			tmpVal = 0;
			if (target.type === 'duct' && hsi) {
				tmpVal = 1 / (hsi * innerDiam[0]);
			}
			for (i = 0; i < arrLength; i++) {
				if (lambda[i] == 0) continue;
				tmpVal += ( 1 / (2 * lambda[i]) ) * Math.log( (outerDiam[i] / innerDiam[i]) );
			}
			phi = (Math.PI * (innerTemp - outerTemp) ) / ( tmpVal + 1 / (alpha * outerDiam[arrLength - 1]) );
		} else {
			phi = (Math.PI * (innerTemp - outerTemp) ) / ( ( 1 / (2 * lambda[0]) ) * Math.log( (outerDiam[0] / innerDiam[0]) ) + 1 / (alpha * outerDiam[0]) );
		}
	} else {
		if (insulThick.length > 1) {
			arrLength = insulThick.length;
			tmpVal = 0;
			if (target.type === 'duct' && hsi) {
				tmpVal = 1 / hsi;
			}
			for (i = 0; i < arrLength; i++) {
				if (lambda[i] == 0) continue;
				tmpVal += insulThick[i] / lambda[i];
			}
			phi = (innerTemp - outerTemp) / ( tmpVal + (1 / alpha) );
			// phi = (innerTemp - outerTemp ) / ( tmpVal ) + alpha * ( target.surfaceTemp - outerTemp - solarAffect);
		} else {
			// phi = (innerTemp - outerTemp) / ( (insulThick[0] / lambda[0]) ) + alpha * (target.surfaceTemp - outerTemp - solarAffect);
			phi = (innerTemp - outerTemp) / ( (insulThick[0] / lambda[0]) + (1 / alpha) );
		}
		// if(target.solarAffect) {
		// 	phi += (- solarAffect) * alpha
		// }
	}
	return phi;
}

export function surfaceTemperature( type,  phi,  alpha,  outerTemp,  outerDiam, target) {
	var retVal;

	// const solarAffect = 0
	if (type == 'pipe') {
		retVal = outerTemp + (phi / Math.PI) * (1 / (alpha * outerDiam ));
	} else {
		retVal = outerTemp + phi / alpha; // alpha = Hse, phi = insulation heat transfer
	}

	return retVal;
}

export function surfaceTemperatureLayers( type,  phi,  calcLambda,  innerTemp,  insulThick,  innerDiam,  outerDiam) {
	var retVal;

	if (type == 'pipe') {
		retVal = innerTemp - (phi / Math.PI) * (1 / (2 * calcLambda)) * ( Math.log(outerDiam / innerDiam) );
	} else {
		retVal = innerTemp - ( (phi * insulThick) / calcLambda);
	}

	return retVal;
}

export function surfaceTemperatureLayersInverse( type,  phi,  calcLambda,  outerTemp, insulThick,  innerDiam,  outerDiam) {
	var retVal;

	if (type == 'pipe') {
		retVal = outerTemp + (phi / Math.PI) * (1 / (2 * calcLambda)) * ( Math.log(outerDiam / innerDiam) );
	} else {
		retVal = outerTemp - ( (phi * insulThick) / calcLambda);
	}

	return retVal;
}

/* export function protectiveInsulation( type,  epsilon,  innerTemp,  outerTemp, surfaceTemp,  lambdaArr,  airV) {
	var retVal;
	var calcLambda;
	var calcAlphaE;

	if (type == "pipe") {
		// TODO:

	} else {
		calcLambda = getLambdaVal( ( (surfaceTemp - innerTemp) / 2 ), lambdaArr, (target.claddingSupport ?target.claddingSupportInfluence :0));
		calcAlphaE = alphaE(type, epsilon, outerTemp, surfaceTemp, -1, airV);
		retVal = (calcLambda / calcAlphaE) * ( (innerTemp - surfaceTemp) / (surfaceTemp / outerTemp) );
	}

	return retVal;
} */

/*


##     ## ########    ###    ######## ##        #######   ######   ######     #### ######## ######## ########     ###    ######## #### ##     ## ########
##     ## ##         ## ##      ##    ##       ##     ## ##    ## ##    ##     ##     ##    ##       ##     ##   ## ##      ##     ##  ##     ## ##
##     ## ##        ##   ##     ##    ##       ##     ## ##       ##           ##     ##    ##       ##     ##  ##   ##     ##     ##  ##     ## ##
######### ######   ##     ##    ##    ##       ##     ##  ######   ######      ##     ##    ######   ########  ##     ##    ##     ##  ##     ## ######
##     ## ##       #########    ##    ##       ##     ##       ##       ##     ##     ##    ##       ##   ##   #########    ##     ##   ##   ##  ##
##     ## ##       ##     ##    ##    ##       ##     ## ##    ## ##    ##     ##     ##    ##       ##    ##  ##     ##    ##     ##    ## ##   ##
##     ## ######## ##     ##    ##    ########  #######   ######   ######     ####    ##    ######## ##     ## ##     ##    ##    ####    ###    ########


 */
export function heatLossIterative( type,  epsilon,  innerTemp,  outerTemp,  lambdaArr,  airV,  insulThick,  innerDiam,  outerDiam, calculatePlainObject, target = null) {
/*			var viceVersa:Boolean = false;
	if (outerTemp > innerTemp) {
		viceVersa = true;
		var tmpVal = innerTemp;
		innerTemp = outerTemp;
		outerTemp = tmpVal;
	}
console.log('type: ', type, ', epsilon: ', epsilon, ', innerTemp: ', innerTemp, ', outerTemp: ', outerTemp,
	  ', lambdaArr: ', lambdaArr,  ', airV:',  airV, ', insulThick:', insulThick, ', innerDiam: ', innerDiam, ', outerDiam: ', outerDiam, ', calculatePlainObject: ', calculatePlainObject)
	*/
	var i, j;
	var frstValues = [];

	const numberOfInsulationLayers = lambdaArr.length - 1;

	// console.log({numberOfInsulationLayers, section:target.isSection})
	const additionToLambda = (target.claddingSupport ? target.claddingSupportInfluence : 0) + (target.mechanicalFasteners ? target.mechanicalInfluence : 0);

	// Slicing the insulation layers into 10mm slices
	if (!calculatePlainObject) {
		var tmpInsArr = [];
		var tmpInsLambdaArr = [];
		var tmpInnerArr = [];
		var tmpOuterArr = [];
		var dividedLayers = [];

		// Planes
		if(type != 'pipe' ) {
			for (i = 1; i < insulThick.length; i++) {
				if (insulThick[i] > 0.01) {
					dividedLayers[i] = 0;
					for (j = 0; j < Math.floor(insulThick[i] / 0.01); j++) {
						dividedLayers[i]++;
						tmpInsArr.push(0.01);
						tmpInsLambdaArr.push(lambdaArr[i]);
					}
					if ( (insulThick[i] % 0.01) > 0 ) {
//					if ( Math.floor(insulThick[i]/0.01) != Math.round(insulThick[i]/0.01) ) {
						dividedLayers[i]++;
						tmpInsArr.push( Math.round( (((insulThick[i] / 0.01) - Math.floor(insulThick[i] / 0.01)) * 0.01) * 1000 ) / 1000 );
						tmpInsLambdaArr.push(lambdaArr[i]);
					}
				} else {
					dividedLayers[i] = 1;
					tmpInsArr.push(insulThick[i]);
					tmpInsLambdaArr.push(lambdaArr[i]);
				}
			}
			frstValues = [insulThick[0], lambdaArr[0]];
			insulThick = tmpInsArr;
			lambdaArr = tmpInsLambdaArr;

			insulThick.splice(0, 0, frstValues[0]);
			lambdaArr.splice(0, 0, frstValues[1]);

		// Pipes
		} else {
			dividedLayers[0] = 0;
			for (i = 1; i < innerDiam.length; i++) {
				var tmpThick = Math.round( (outerDiam[i] - innerDiam[i]) * 1000) / 1000;
//						var tmpThick = outerDiam[i] - innerDiam[i];
				dividedLayers[i] = 0;

				// //trace("Values " + outerDiam[i] +", " + innerDiam[i] + ", res: " + ( innerDiam[i]*100 - outerDiam[i]*100) ) ;
				if (tmpThick > 0.02) {
					for (j = 0; j < Math.floor(tmpThick / 0.02); j++) {
						dividedLayers[i]++;
						tmpInsLambdaArr.push(lambdaArr[i]);
						tmpInnerArr.push(  Math.round( (innerDiam[i] + j * 0.02) * 1000 ) / 1000 );
						tmpOuterArr.push( Math.round( (innerDiam[i] + (j + 1) * 0.02) * 1000) / 1000 );
					}
					if ( (tmpThick % 0.02) > 0 ) { // Damn you Math class
//					if ( Math.floor((tmpThick / 0.02)*1000) != Math.round( ( tmpThick / 0.02 ) * 1000) ) {
						dividedLayers[i]++;
						tmpInsLambdaArr.push(lambdaArr[i]);
						tmpInnerArr.push( Math.round( (innerDiam[i] + j * 0.02) * 1000 ) / 1000 );
						tmpOuterArr.push( Math.round( (innerDiam[i] + j * 0.02 + ((tmpThick / 0.02) - Math.floor(tmpThick / 0.02)) * 0.02) * 1000 ) / 1000);
					}
				} else {
					dividedLayers[i] = 1;
					tmpInsLambdaArr.push(lambdaArr[i]);
					tmpInnerArr.push(innerDiam[i]);
					tmpOuterArr.push(outerDiam[i]);
				}
			}
			frstValues = [innerDiam[0], outerDiam[0], lambdaArr[0]];
			innerDiam = tmpInnerArr;
			outerDiam = tmpOuterArr;
			lambdaArr = tmpInsLambdaArr;
			innerDiam.splice(0, 0, frstValues[0]);
			outerDiam.splice(0, 0, frstValues[1]);
			lambdaArr.splice(0, 0, frstValues[2]);
		}
	}
	// End slicing

	// environment temperature is the same as content temperature
	if (innerTemp == outerTemp) {
		var l = [];
		var s = [];
		if (!calculatePlainObject) {
			for (i = 1; i < lambdaArr.length; i++) {
				l.push([getLambdaVal(
					innerTemp / 100,
					lambdaArr[i],
					additionToLambda,
					( target.isSection
						? 1
						: ( numberOfInsulationLayers === 1
							? 1.1
							: (numberOfInsulationLayers === 2
								? 1.05
								: 1
						))
					)
					)]);
				s.push(outerTemp);
			}
			l.splice(0, 0, lambdaArr[0]);
			s.splice(0, 0, outerTemp);
		} else {
			l.push(lambdaArr[0]);
			s.push(outerTemp);
		}
		var a = alphaE(type, epsilon, outerTemp + KELVINCORRECTION, innerTemp + KELVINCORRECTION, outerDiam[layers - 1], airV, {...target, diameter: outerDiam[layers - 1], noIns: calculatePlainObject, innerTemp});

		let tmpValR;
		if (epsilon > 0 ) tmpValR = alphaR(epsilon, outerTemp + KELVINCORRECTION, innerTemp + KELVINCORRECTION);
		let tmpValK;
		let tmpValHsi = 0;
		if(calculatePlainObject) {
			tmpValK = hcv( {surfaceTemp: innerTemp, ambientTemp: outerTemp, airV, target: {...target, diameter: outerDiam[0], noLog: true, innerTemp} });
		} else {
			tmpValK = hcv( {surfaceTemp: innerTemp, ambientTemp: outerTemp, airV, target: {...target, noLog: true, innerTemp} });
		}
		// tmpValK = alphaK(type, outerTemp+KELVINCORRECTION, innerTemp+KELVINCORRECTION, outerDiam[layers-1], airV);
		if(target.type === 'duct' && target.content === 'Air' && target.insideTemp >= -50 && target.insideTemp <= 100 && target.length > 0 && target.flowRate > 0) {
			tmpValHsi = calcHsi({surfaceTemp: innerTemp, ambientTemp: outerTemp, airV, target: {...target, innerTemp}});
		}

		return [ l, a, 0, s, [tmpValR, tmpValK, tmpValHsi, additionToLambda, ( target.isSection
			? 1
			: ( numberOfInsulationLayers === 1
				? 1.1
				: (numberOfInsulationLayers === 2
					? 1.05
					: 1
			))
		)]];
	}


	// Start actual heatloss iteration
	var retArr = [];
	var calcLambda = [];
	var intermediateTemp = [];
	var calcAlphaE;
	var calcPhi;

	var outerSurfaceTemp = outerTemp +  (Math.abs(innerTemp - outerTemp) * 0.2) * ( (innerTemp - outerTemp) / Math.abs(innerTemp - outerTemp));
	var layers = lambdaArr.length;
	var surfaceTemp = [];
	var calcSurfaceTemp = [];
	// var calcSurfaceTempInverse = [];

	for (i = 0; i < layers; i++) {
		surfaceTemp.push( (innerTemp - (innerTemp - outerSurfaceTemp) * (i + 1) / layers) );
		calcSurfaceTemp.push( (innerTemp - (innerTemp - outerSurfaceTemp) * (i + 1) / layers) );
		// calcSurfaceTempInverse.push( (innerTemp - (innerTemp-outerSurfaceTemp)*(i+1)/layers) );
	}

// console.log('surfaceTemp: ',surfaceTemp,'| calcSurfaceTemp: ',calcSurfaceTemp)

	var round = 0;
	do {
		surfaceTemp = calcSurfaceTemp;

		calcLambda = [];
		intermediateTemp = [];
		if (!calculatePlainObject) {
			for (i = 0; i < layers; i++) {
				if (i == 0) {
					intermediateTemp.push( (innerTemp + surfaceTemp[i]) / 2);
					calcLambda.push(lambdaArr[i]);
				} else {
					intermediateTemp.push( (surfaceTemp[i - 1] + surfaceTemp[i]) / 2);
					calcLambda.push([getLambdaVal(
						intermediateTemp[i] / 100,
						lambdaArr[i],
						additionToLambda,
						( target.isSection
							? 1
							: ( numberOfInsulationLayers === 1
								? 1.1
								: (numberOfInsulationLayers === 2
									? 1.05
									: 1
							))
						)
						)]);
				}
			}
		} else {
			calcLambda.push(lambdaArr[0]);
		}

// console.log('calcLambda: ',calcLambda, ', withoutinsulation: ',calculatePlainObject)

		if( target ) {
		// surfaceTemp, ambientTemp, airV=0, target,
			// calcAlphaE = hcv( {surfaceTemp: surfaceTemp[layers-1], ambientTemp:outerTemp, airV, target:{...target, diameter: outerDiam[layers-1]} });
			calcAlphaE =  alphaE(type, epsilon, outerTemp + KELVINCORRECTION, surfaceTemp[layers - 1] + KELVINCORRECTION, outerDiam[layers - 1], airV, {...target, diameter: outerDiam[layers - 1], noIns: calculatePlainObject, roundIndex: round, innerTemp});
			// console.log({calcAlphaE})
		} else {
			calcAlphaE = alphaE(type, epsilon, outerTemp + KELVINCORRECTION, surfaceTemp[layers - 1] + KELVINCORRECTION, outerDiam[layers - 1], airV);
		}
		// calcPhi = heatLoss(type, innerTemp + KELVINCORRECTION, surfaceTemp[layers-1] + KELVINCORRECTION, calcLambda, calcAlphaE, insulThick, innerDiam, outerDiam, {...target, surfaceTemp:surfaceTemp[layers-1]+KELVINCORRECTION});
		let tmpValHsi = 0;
		if(target.type === 'duct' && target.content === 'Air' && target.insideTemp >= -50 && target.insideTemp <= 100 && target.length > 0 && target.flowRate > 0) {
			tmpValHsi = calcHsi({surfaceTemp: innerTemp, ambientTemp: outerTemp, airV, target: {...target, innerTemp, noLog: true}});
		}

		calcPhi = heatLoss(type, innerTemp + KELVINCORRECTION, outerTemp + KELVINCORRECTION, calcLambda, calcAlphaE, insulThick, innerDiam, outerDiam, tmpValHsi, {...target, surfaceTemp: surfaceTemp[layers - 1] + KELVINCORRECTION});
// console.log('calcAlphaE: ',calcAlphaE,', calcPhi: ',calcPhi, ', withoutinsulation: ',calculatePlainObject);
		calcSurfaceTemp = [];
		for (i = 0;  i < layers; i++) {
			if (i == layers - 1) {
				calcSurfaceTemp.push(surfaceTemperature(type, calcPhi, calcAlphaE, outerTemp + KELVINCORRECTION, outerDiam[i], target) - KELVINCORRECTION);
			} else if (i == 0) {
				calcSurfaceTemp.push(surfaceTemperatureLayers(type, calcPhi, calcLambda[i], innerTemp + KELVINCORRECTION, insulThick[i], innerDiam[i], outerDiam[i]) - KELVINCORRECTION);
			} else {
				calcSurfaceTemp.push(surfaceTemperatureLayers(type, calcPhi, calcLambda[i], surfaceTemp[i - 1] + KELVINCORRECTION, insulThick[i], innerDiam[i], outerDiam[i]) - KELVINCORRECTION);
			}
		}

// console.log('round: '+(round+1),'| surfaceTemp: ',surfaceTemp,'| calcSurfaceTemp: ',calcSurfaceTemp)

/*
		calcSurfaceTempInverse = [];
		for (i = layers;  i >-1 ; i--) {
			if (i == layers) {
				calcSurfaceTempInverse.push(surfaceTemperature(type, calcPhi, calcAlphaE, outerTemp+KELVINCORRECTION, outerDiam[i-1])-KELVINCORRECTION);
			} else {
				calcSurfaceTempInverse.push(surfaceTemperatureLayersInverse(type, calcPhi, calcLambda[i], surfaceTemp[i]+KELVINCORRECTION, insulThick[i], innerDiam[i], outerDiam[i])-KELVINCORRECTION);
			}
		}
		calcSurfaceTempInverse.reverse();
*/

		round++;
		if (round > 100) break;
	} while ( checkMultiIteration(surfaceTemp, calcSurfaceTemp) );// calcSurfaceTempInverse[0] != innerTemp);// checkMultiIteration(surfaceTemp, calcSurfaceTemp) );

/*
	if (viceVersa) {
		calcSurfaceTemp.reverse();
		calcLambda.reverse();
		calcPhi = -calcPhi;
	}

*/

	// Compile the sliced layers back into original layout
		// console.log('calcSurfaceTemp: ',calcSurfaceTemp, ' | calcLambda: ',calcLambda, ' | dividedLayers: ',dividedLayers);

	if (!calculatePlainObject) {
		var tmpCalcLambda = [];
		var tmpCalcSurfaceTemp = [calcSurfaceTemp[0]];
		var tmpStartPoint = 1;
		for (i = 1; i < dividedLayers.length; i++) {
			tmpCalcLambda[i - 1] = calcLambda[tmpStartPoint + dividedLayers[i] - 1];
			tmpCalcSurfaceTemp[i] = calcSurfaceTemp[tmpStartPoint + dividedLayers[i] - 1];
			tmpStartPoint += dividedLayers[i];
		}
		// console.log(calcSurfaceTemp, '<->', tmpCalcSurfaceTemp)

		calcLambda = tmpCalcLambda;
		calcSurfaceTemp = tmpCalcSurfaceTemp;
// console.log('calcLambda: ',calcLambda)
		if(type == 'pipe' ) { calcLambda.splice(0, 0, calcLambda[0]); }
	}

	let tmpValR;
	let tmpValK;
	let tmpValHsi = 0;
	if (epsilon > 0 ) tmpValR = alphaR(epsilon, outerTemp + KELVINCORRECTION, surfaceTemp[layers - 1] + KELVINCORRECTION);
	if(target) {
		if(calculatePlainObject) {
			tmpValK = hcv( {surfaceTemp: innerTemp, ambientTemp: outerTemp, airV, target: {...target, diameter: outerDiam[0], noLog: true, innerTemp} });
		} else {
			tmpValK = hcv( {surfaceTemp: surfaceTemp[layers - 1], ambientTemp: outerTemp, airV, target: {...target, noLog: true, innerTemp} });
		}
		if(target.type === 'duct' && target.content === 'Air' && target.insideTemp >= -50 && target.insideTemp <= 100 && target.length > 0 && target.flowRate > 0) {
			tmpValHsi = calcHsi({surfaceTemp: innerTemp, ambientTemp: outerTemp, airV, target: {...target, innerTemp}});
		}
	} else {
		tmpValK = alphaK(type, outerTemp + KELVINCORRECTION, surfaceTemp[layers - 1] + KELVINCORRECTION, outerDiam[layers - 1], airV);
	}

	retArr = [calcLambda, calcAlphaE, calcPhi, calcSurfaceTemp, [tmpValR, tmpValK, tmpValHsi, additionToLambda, ( target.isSection
		? 1
		: ( numberOfInsulationLayers === 1
			? 1.1
			: (numberOfInsulationLayers === 2
				? 1.05
				: 1
		))
	)
]];

// console.log('--------->',retArr)
	return retArr;
}

function checkMultiIteration( orig,  modif) {
	// console.log("orig: " + orig + ", modif: " + modif);
	for (var i = 0;  i < orig.length; i++)
	{
		// console.log(orig[i], '<->' ,modif[i])
		if ( Math.abs(orig[i] - modif[i]) >= TEMPDIFFERENCE) return true;
	}
	return false;
}

export function massFlow( innerDiam,  mediumV,  mediumDensity, thickness) {
	var retVal;

	// retVal = ((Math.PI * Math.pow((innerDiam-thickness), 2)) / 4 ) * (mediumV * mediumDensity);
	retVal = (Math.PI * Math.pow((innerDiam / 2 - thickness), 2)) * (mediumV * mediumDensity);

	return retVal;
}

export function temperatureDrop( innerDiam,  mediumV,  mediumDensity,  pipeL,  innerTemp,  outerTemp,  mediumHeatCap,  heatLossVal, thickness) {
// console.log( innerDiam,' | ',  mediumV,' | ',  mediumDensity,' | ',  pipeL, ' | ', innerTemp,' | ',  outerTemp,' | ',  mediumHeatCap,' | ',  heatLossVal,' | ', thickness)
	var retVal;

	if (mediumV == 0) return NaN;
	if(innerTemp == outerTemp) return innerTemp;

	var calcMassFlow = massFlow(innerDiam, mediumV, mediumDensity, thickness);
//	var pipeLinDen = ( (Math.PI * Math.pow( innerDiam/2, 2)) - ( Math.PI * Math.pow( (innerDiam/2 - thickness), 2) ) ) * materialDensity;
	var ePow = (pipeL * heatLossVal) / ( calcMassFlow * (mediumHeatCap * 1000) * (innerTemp - outerTemp) );
	retVal = outerTemp + (innerTemp - outerTemp) / Math.pow(Math.E, ePow);
	return retVal;
}

export function temperatureDropRectDuct( ductWidth, ductHeight, mediumV,  mediumDensity,  ductL,  innerTemp,  outerTemp,  mediumHeatCap,  heatLossVal, thickness) {
	// console.log({ductWidth, ductHeight, mediumV,  mediumDensity,  ductL,  innerTemp,  outerTemp,  mediumHeatCap,  heatLossVal, thickness})
	var retVal;
	if (mediumV == 0) return NaN;
	if(innerTemp == outerTemp) return innerTemp;

	var calcMassFlow = ( (ductWidth - thickness * 2) * (ductHeight - thickness * 2) ) * (mediumV * mediumDensity);
	// var ductLinDen = ( (ductHeight*2 + ductWidth*2) * thickness ) * materialDensity;
	var ePow = (ductL * heatLossVal) / ( calcMassFlow * (mediumHeatCap * 1000) * (innerTemp - outerTemp) );

	retVal = outerTemp + (innerTemp - outerTemp) / Math.pow(Math.E, ePow);

	return retVal;
}

/*
 * return time in seconds
 */
export function freezingTimePipe( innerTemp,  outerTemp, phi, innerDiam, mediumHeatCap,  mediumDensity,  mediumFP,  pipeMaterialHeatCap,  pipeMaterialDensity,  pipeMaterialThick) {
// console.log( ' innerTemp',innerTemp,  ' outerTemp', outerTemp, ' phi',phi, ' innerDiam',innerDiam, ' mediumHeatCap',mediumHeatCap,  ' mediumDensity',mediumDensity,  ' mediumFP',mediumFP,  ' pipeMaterialHeatCap',pipeMaterialHeatCap,  ' pipeMaterialDensity',pipeMaterialDensity,  ' pipeMaterialThick',pipeMaterialThick)
	var tmpVal = 0;
	var tauJ;

	// if (outerTemp >= mediumFP) return NaN;
	if( (outerTemp < innerTemp && ( outerTemp >= mediumFP || mediumFP > innerTemp) ) || ( outerTemp > innerTemp && ( outerTemp < mediumFP || mediumFP < innerTemp) ) ) return NaN;

	tmpVal = (Math.PI * (innerTemp - outerTemp) ) / phi;

	// var mediumLinDen = (Math.PI * Math.pow( innerDiam/2, 2) ) * mediumDensity;
	// var pipeLinDen = ( (Math.PI * Math.pow( (innerDiam + 2*pipeMaterialThick)/2, 2)) - ( Math.PI * Math.pow(innerDiam/2, 2) ) ) * pipeMaterialDensity;
	var mediumLinDen = (Math.PI * Math.pow( (innerDiam / 2 - pipeMaterialThick), 2) ) * mediumDensity;
	var pipeLinDen = ( (Math.PI * Math.pow( innerDiam / 2, 2)) - ( Math.PI * Math.pow( (innerDiam / 2 - pipeMaterialThick), 2) ) ) * pipeMaterialDensity;

	// this formula was taken from SFS 3977, changed to match ISO 12241 2008
	// tauJ = (1 / Math.PI) * ( ( ( (mediumHeatCap * 1000) * mediumLinDen + (pipeMaterialHeatCap * 1000) * pipeLinDen) * ( innerTemp - mediumFP )  ) / ( ( ( innerTemp + KELVINCORRECTION + mediumFP + KELVINCORRECTION) ) / 2 - (outerTemp + KELVINCORRECTION)) ) * tmpVal;

	tauJ =  ( ( (mediumHeatCap * 1000) * mediumLinDen + (pipeMaterialHeatCap * 1000) * pipeLinDen) * ( innerTemp - outerTemp )  ) * Math.log( (innerTemp - outerTemp) / (mediumFP - outerTemp)) / phi;
	return tauJ;
}

/*
 * return time in seconds
 */
export function coolingTimePipe( innerTemp,  outerTemp, endTemp, phi, innerDiam, outerDiam, mediumHeatCap,  mediumDensity,   pipeMaterialHeatCap,  pipeMaterialDensity,  pipeMaterialThick) {
// console.log( 'innerTemp: ', innerTemp, ' | outerTemp: ',  outerTemp, ' | endTemp: ', endTemp, ' | phi: ', phi, ' | innerDiam: ', innerDiam, ' | outerDiam: ', outerDiam, ' | mediumHeatCap: ', mediumHeatCap,  ' | mediumDensity: ',  mediumDensity,   ' | pipeMaterialHeatCap: ',   pipeMaterialHeatCap,  ' | pipeMaterialDensity: ',  pipeMaterialDensity,  ' | pipeMaterialThick: ',  pipeMaterialThick)
	var tmpVal = 0;
	var tauJ;

	if( (outerTemp < innerTemp && ( outerTemp >= endTemp || endTemp > innerTemp) ) || ( outerTemp > innerTemp && ( outerTemp < endTemp || endTemp < innerTemp) ) ) return NaN;

	var mediumLinDen = (Math.PI * Math.pow( innerDiam / 2, 2) ) * mediumDensity;
	var pipeLinDen = ( (Math.PI * Math.pow( (innerDiam + 2 * pipeMaterialThick) / 2, 2)) - ( Math.PI * Math.pow(innerDiam / 2, 2) ) ) * pipeMaterialDensity;
	var totalHeatCap = (mediumHeatCap * 1000) * mediumLinDen + (pipeMaterialHeatCap * 1000) * pipeLinDen;

	tauJ = ( totalHeatCap / ( ( Math.PI * outerDiam * Math.abs(phi) ) ) ) * Math.log( (innerTemp - outerTemp) / (endTemp - outerTemp) );
	// tauJ = ( totalHeatCap / ( ( Math.PI * (outerDiam+innerDiam)/2 * Math.abs(phi) ) ) ) * Math.log( (innerTemp - outerTemp) / (endTemp - outerTemp) );

	return tauJ;
}

/*
 * return time in hours
 */
export function freezingTimePipeToValue( frozenToValue, outerTemp, lambda, innerDiam, outerDiam, pipeL) {
// console.log( 'frozenToValue: ',frozenToValue, ' | outerTemp: ', outerTemp, ' | lambda: ', lambda, ' | innerDiam: ', innerDiam, ' | outerDiam: ', outerDiam, ' | pipeL:', pipeL)
	var tmpVal;
	var arrLength;
	var i;
	var phiTFr;
	var tauFr;

/*	if (innerDiam.length > 1) {
		arrLength = innerDiam.length;
		tmpVal = 0;
		for (i = 0; i < arrLength; i++) {
			if (lambda[i] == 0) continue;
			tmpVal += ( 1 / (2 * lambda[i]) ) * Math.log( (outerDiam[i] / innerDiam[i]) );
		}
		phiTFr = ( (Math.PI * ( -outerTemp) ) / tmpVal ) * pipeL;
	} else {
		phiTFr = ( (Math.PI * ( -outerTemp) ) / ( ( 1 / (2 * lambda[0]) ) * Math.log( (outerDiam[1] / innerDiam[1]) ) ) ) * pipeL;
	}
*/
	tmpVal = 0;
	for (i = 0; i < innerDiam.length; i++) {
		if (lambda[i] == 0) continue;
		tmpVal += ( 1 / (2 * lambda[i]) ) * Math.log( (outerDiam[i] / innerDiam[i]) );
	}
	phiTFr = ( (Math.PI * ( -outerTemp) ) / tmpVal ) * pipeL;
	tauFr = (frozenToValue / 100) * ( ( DENSITYOFICEATZERO * Math.PI * Math.pow(innerDiam[0], 2) * LATENTHEATOFICE) / (phiTFr * 3.6 * 4));

	return tauFr;
}

export function dewPoint( outerTemp,  rh) {
	// console.log( 'outerTemp: ',outerTemp,  ' | rh:',  rh)

	var retVal;
	var calcRh = rh / 100;

	retVal = ( 237.7 * ( (17.27 * outerTemp) / (237.7 + outerTemp) + Math.log(calcRh) ) ) / (17.27 - ( (17.27 * outerTemp) / (237.7 + outerTemp) + Math.log(calcRh) ) );

	return retVal;
}

/*
 *
 */
export function emissionCO2(type, emissionPerKWH, hoursPerYear, phi, planeWidth, planeHeight, lengthPipe) {
	var retVal;

//	console.log(type, emissionPerKWH, hoursPerYear, phi, planeWidth, planeHeight, lengthPipe)
	if (type == 'pipe') {
		retVal = emissionPerKWH * (phi * lengthPipe) * parseFloat(hoursPerYear) / 1000;
	} else {
		retVal = emissionPerKWH * (phi * planeWidth * planeHeight) * parseFloat(hoursPerYear) / 1000;
	}
	// values in database are filled in as g/kWh, values needed were g/Wh => divide by 1000
	return retVal / 1000;
}

/*
 *
 */
export function annualCost(type, phi, energyPrice, hoursPerYear, planeWidth, planeHeight, lengthPipe) {
	var retVal;

//	console.log(type, phi, energyPrice, hoursPerYear, planeWidth, planeHeight, lengthPipe);
	// ////////////trace("((" + phi + " * " + lengthPipe + ") / 1000) * " + hoursPerYear + " * " + energyPrice + ")");

	if (type == 'pipe') {
		retVal = ((phi * lengthPipe) / 1000) * parseFloat(hoursPerYear) * parseFloat(energyPrice);
	} else {
		retVal = ((phi * planeWidth * planeHeight) / 1000) * parseFloat(hoursPerYear) * parseFloat(energyPrice);
	}

	return retVal;
}

export function annualCostKwh(type, phi, hoursPerYear, planeWidth, planeHeight, lengthPipe) {
	var retVal;

	// console.log(type, phi, hoursPerYear, planeWidth, planeHeight, lengthPipe);
	// ////////////trace("((" + phi + " * " + lengthPipe + ") / 1000) * " + hoursPerYear + " * " + energyPrice + ")");

	if (type == 'pipe') {
		retVal = ((phi * lengthPipe)) * parseFloat(hoursPerYear);
	} else {
		retVal = ((phi * planeWidth * planeHeight)) * parseFloat(hoursPerYear);
	}

	// console.log('--->',retVal)
	return retVal;
}

export function annualAdaptersCost(energy, energyPrice, hoursPerYear) {
	var retVal;

//	console.log(type, phi, energyPrice, hoursPerYear, planeWidth, planeHeight, lengthPipe);
	// ////////////trace("((" + phi + " * " + lengthPipe + ") / 1000) * " + hoursPerYear + " * " + energyPrice + ")");

	retVal = energy / 1000 * parseFloat(hoursPerYear) * parseFloat(energyPrice);

	return retVal;
}

/*
 * return time in seconds
 */
export function coolingTimeVessel(startTemp, endTemp, outerTemp, phi, areas, vesselVolume, mediumHeatCapacity, mediumDensity) {
	var retVal;
	var deviderTotal;
	var mass;
	var i;

//	console.log( 'coolingTimeVessel: ',startTemp, ' | ', endTemp, ' | ', outerTemp, ' | ', phi, ' | ', areas, ' | ', vesselVolume, ' | ', mediumHeatCapacity, ' | ', mediumDensity )

	deviderTotal = 0;
	for (i = 0; i < phi.length; i++) {
		deviderTotal += phi[i] * areas[i];
	}
	mass = vesselVolume * mediumDensity;
	retVal = (mediumHeatCapacity * 1000 * mass * (startTemp - outerTemp) * Math.log( (startTemp - outerTemp) / (endTemp - outerTemp))) / deviderTotal;

	return retVal;
}

/*
 * return temperature in celcius
 */
export function temperatureDropVessel(startTemp, outerTemp, coolingTime, phi, areas, vesselVolume, mediumHeatCapacity, mediumDensity) {
	var retVal;
	var tmpTotal;
	var mass;
	var tmpVal;
	var i;

	tmpTotal = 0;
	for (i = 0; i < phi.length; i++) {
		tmpTotal += phi[i] * areas[i];
	}
	mass = vesselVolume * mediumDensity;

	tmpVal = (tmpTotal * coolingTime) / (mediumHeatCapacity * 1000 * mass * (startTemp - outerTemp));

	retVal = (startTemp - outerTemp) / Math.pow(Math.E, tmpVal) + outerTemp;

	return retVal;
}

export function solveLambdaArray(xs, ys ) {
	/* console.log('x-->', xs);
	console.log('y-->', ys); */

	let m = genMatrix(4, 4);

	m = [[ 1, xs[0], Math.pow(xs[0], 2), Math.pow(xs[0], 3) ], [ 1, xs[1], Math.pow(xs[1], 2), Math.pow(xs[1], 3) ], [ 1, xs[2], Math.pow(xs[2], 2), Math.pow(xs[2], 3) ], [ 1, xs[3], Math.pow(xs[3], 2), Math.pow(xs[3], 3) ]];

	let t = transpose(m);

	let multi = matrixMult(t, m);

	let inv = inverse(multi);

	let tmpM = matrixMult(inv, t);

	let resVal = matrixVectorMult(tmpM, ys);

	resVal[1] = resVal[1] * 100;
	resVal[2] = resVal[2] * 10000;
	resVal[3] = resVal[3] * 1000000;

	return resVal;
}

export function unitConversion(value, convertFromUnit, targetType, pipeDiameter, rectDuctWidth, rectDuctHeight, mediumDensity, thickness) {
	// console.log({value, convertFromUnit, targetType, pipeDiameter, rectDuctWidth, rectDuctHeight, mediumDensity, thickness})
	var tmpVal;
	var retVal = value;
	var targetArea;
	var conv_M3H_2_M3S = 0.00027778;

	if (targetType == 'pipe') {
		targetArea = Math.PI * Math.pow( ( (pipeDiameter / 2) - thickness ), 2);
	} else {
		targetArea = (rectDuctHeight - (thickness * 2)) * (rectDuctWidth - (thickness * 2));
	}
	if (convertFromUnit == 'kg/s') {
		tmpVal = value / mediumDensity;
		retVal = tmpVal / targetArea;
	} else if (convertFromUnit == 'm³/h') {
		tmpVal = value * conv_M3H_2_M3S;
		retVal = tmpVal / targetArea;
	} else if (convertFromUnit == 'l/s') {
		tmpVal = value / 1000;
		retVal = tmpVal / targetArea;
	}

	return retVal;
}

export function heatlossConvertLengthToArea(heatlossVal, circOuterDiam, rectOuterWidth, rectOuterHeight) {
	var areaInOneM;

	// console.log('------------------------->',heatlossVal, ' -- ', circOuterDiam, ' -- ', rectOuterWidth, ' -- ', rectOuterHeight);
	if (circOuterDiam) {
		areaInOneM = Math.PI * circOuterDiam;
	} else {
		areaInOneM = rectOuterHeight * 2 + rectOuterWidth * 2;
	}
	var heatlossInSqrM = heatlossVal / areaInOneM;
	return heatlossInSqrM;
}

export function calculateUValues(targetType, heatLoss, mediumTemp, outsideTemp, pipeDiameter, rectDuctWidth, rectDuctHeight, klasse, settings, useGlobalValues, country) {
	var pipeM = 0;
	var pipeA = 0;
	var flatV = 0;
	var pipeDef = 0.4;

	if (klasse !== null) {
		if(useGlobalValues) {
			pipeDef = parseFloat(settings['global-pipe-diameter-definition']);
			switch(klasse) {
				case 0:
					pipeM = parseFloat(settings['global-class1-pipe-multiplier']);
					pipeA = parseFloat(settings['global-class1-pipe-addition']);
					flatV = parseFloat(settings['global-class1-flat-surface']);
					break;
				case 1:
					pipeM = parseFloat(settings['global-class2-pipe-multiplier']);
					pipeA = parseFloat(settings['global-class2-pipe-addition']);
					flatV = parseFloat(settings['global-class2-flat-surface']);
					break;
				case 2:
					pipeM = parseFloat(settings['global-class3-pipe-multiplier']);
					pipeA = parseFloat(settings['global-class3-pipe-addition']);
					flatV = parseFloat(settings['global-class3-flat-surface']);
					break;
				case 3:
					pipeM = parseFloat(settings['global-class4-pipe-multiplier']);
					pipeA = parseFloat(settings['global-class4-pipe-addition']);
					flatV = parseFloat(settings['global-class4-flat-surface']);
					break;
				case 4:
					pipeM = parseFloat(settings['global-class5-pipe-multiplier']);
					pipeA = parseFloat(settings['global-class5-pipe-addition']);
					flatV = parseFloat(settings['global-class5-flat-surface']);
					break;
				case 5:
					pipeM = parseFloat(settings['global-class6-pipe-multiplier']);
					pipeA = parseFloat(settings['global-class6-pipe-addition']);
					flatV = parseFloat(settings['global-class6-flat-surface']);
					break;
			}
		} else if(country === 'Denmark') {
			pipeDef = parseFloat(settings['dk-pipe-diameter-definition']);
			switch(klasse) {
				case 0:
					pipeM = parseFloat(settings['dk-class-1-pipe-multiplier']);
					pipeA = parseFloat(settings['dk-class-1-pipe-addition']);
					flatV = parseFloat(settings['dk-class-1-flat-surface']);
					break;
				case 1:
					pipeM = parseFloat(settings['dk-class-2-pipe-multiplier']);
					pipeA = parseFloat(settings['dk-class-2-pipe-addition']);
					flatV = parseFloat(settings['dk-class-2-flat-surface']);
					break;
				case 2:
					pipeM = parseFloat(settings['dk-class-3-pipe-multiplier']);
					pipeA = parseFloat(settings['dk-class-3-pipe-addition']);
					flatV = parseFloat(settings['dk-class-3-flat-surface']);
					break;
				case 3:
					pipeM = parseFloat(settings['dk-class-4-pipe-multiplier']);
					pipeA = parseFloat(settings['dk-class-4-pipe-addition']);
					flatV = parseFloat(settings['dk-class-4-flat-surface']);
					break;
				case 4:
					pipeM = parseFloat(settings['dk-class-5-pipe-multiplier']);
					pipeA = parseFloat(settings['dk-class-5-pipe-addition']);
					flatV = parseFloat(settings['dk-class-5-flat-surface']);
					break;
				case 5:
					pipeM = parseFloat(settings['dk-class-6-pipe-multiplier']);
					pipeA = parseFloat(settings['dk-class-6-pipe-addition']);
					flatV = parseFloat(settings['dk-class-6-flat-surface']);
					break;
			}
		} else if(country === 'Sweden') {
			if(targetType === 'circularDuct' || targetType === 'rectangularDuct') {
				pipeDef = parseFloat(settings['se-duct-diameter-definition']);
				switch(klasse) {
					case 0:
						pipeM = parseFloat(settings['se-class-1-pipe-multiplier-duct']);
						pipeA = parseFloat(settings['se-class-1-pipe-addition-duct']);
						flatV = parseFloat(settings['se-class-1-flat-surface-duct']);
						break;
					case 1:
						pipeM = parseFloat(settings['se-class-2-pipe-multiplier-duct']);
						pipeA = parseFloat(settings['se-class-2-pipe-addition-duct']);
						flatV = parseFloat(settings['se-class-2-flat-surface-duct']);
						break;
					case 2:
						pipeM = parseFloat(settings['se-class-3-pipe-multiplier-duct']);
						pipeA = parseFloat(settings['se-class-3-pipe-addition-duct']);
						flatV = parseFloat(settings['se-class-3-flat-surface-duct']);
						break;
					case 3:
						pipeM = parseFloat(settings['se-class-4-pipe-multiplier-duct']);
						pipeA = parseFloat(settings['se-class-4-pipe-addition-duct']);
						flatV = parseFloat(settings['se-class-4-flat-surface-duct']);
						break;
					case 4:
						pipeM = parseFloat(settings['se-class-5-pipe-multiplier-duct']);
						pipeA = parseFloat(settings['se-class-5-pipe-addition-duct']);
						flatV = parseFloat(settings['se-class-5-flat-surface-duct']);
						break;
					case 5:
						pipeM = parseFloat(settings['se-class-6-pipe-multiplier-duct']);
						pipeA = parseFloat(settings['se-class-6-pipe-addition-duct']);
						flatV = parseFloat(settings['se-class-6-flat-surface-duct']);
						break;
				}
			} else {
				pipeDef = parseFloat(settings['se-pipe-diameter-definition']);
				switch(klasse) {
					case 0:
						pipeM = parseFloat(settings['se-class-1-pipe-multiplier']);
						pipeA = parseFloat(settings['se-class-1-pipe-addition']);
						flatV = parseFloat(settings['se-class-1-flat-surface']);
						break;
					case 1:
						pipeM = parseFloat(settings['se-class-2-pipe-multiplier']);
						pipeA = parseFloat(settings['se-class-2-pipe-addition']);
						flatV = parseFloat(settings['se-class-2-flat-surface']);
						break;
					case 2:
						pipeM = parseFloat(settings['se-class-3-pipe-multiplier']);
						pipeA = parseFloat(settings['se-class-3-pipe-addition']);
						flatV = parseFloat(settings['se-class-3-flat-surface']);
						break;
					case 3:
						pipeM = parseFloat(settings['se-class-4-pipe-multiplier']);
						pipeA = parseFloat(settings['se-class-4-pipe-addition']);
						flatV = parseFloat(settings['se-class-4-flat-surface']);
						break;
					case 4:
						pipeM = parseFloat(settings['se-class-5-pipe-multiplier']);
						pipeA = parseFloat(settings['se-class-5-pipe-addition']);
						flatV = parseFloat(settings['se-class-5-flat-surface']);
						break;
					case 5:
						pipeM = parseFloat(settings['se-class-6-pipe-multiplier']);
						pipeA = parseFloat(settings['se-class-6-pipe-addition']);
						flatV = parseFloat(settings['se-class-6-flat-surface']);
						break;
					case 6:
						pipeM = parseFloat(settings['se-class-7-pipe-multiplier']);
						pipeA = parseFloat(settings['se-class-7-pipe-addition']);
						flatV = parseFloat(settings['se-class-7-flat-surface']);
						break;
				}
			}
		}
	}
// console.log('---------------------->',{heatLoss, mediumTemp,outsideTemp})
	var targetU = Math.abs(Math.round(( heatLoss / Math.abs(mediumTemp - outsideTemp)) * 100) / 100);
	var targetKlasseU = flatV;
	if (targetType == 'pipe' || targetType === 'circularDuct') {
		if (pipeDiameter <= pipeDef) {
			targetKlasseU = pipeM * pipeDiameter + pipeA;
		}
/* 	} else if (targetType == "rectangularDuct") {
		var tmpDiam = (2 * rectDuctHeight + 2 * rectDuctWidth) / Math.PI;
		if (tmpDiam <= pipeDef) {
			targetKlasseU = pipeM * tmpDiam + pipeA;
		} */
	}
	return [targetU, targetKlasseU];
}

export function calculateInsulationWeight(type, innerDiam, outerDiam, length, thickness, width, height, density) {
// console.log(type, ' | ', innerDiam,' | ', outerDiam,' | ', length, ' | ',thickness,' | ', width,' | ', height, ' | ',density);

	let retVal = 0;

	if(type === 'pipe' || type === 'roundtank') {
		for(let i = 0; i < density.length; i++) {
			let area = Math.PI * Math.pow(outerDiam[i + 1] / 2, 2) - Math.PI * Math.pow(innerDiam[i + 1] / 2, 2);
			let volume = area * length;
			let weight = volume * density[i];
			retVal += weight;
		}

		if(type == 'roundtank') {
			retVal = retVal / (Math.PI * outerDiam[0]);
		}
	} else if(type === 'plane') {
		for(let i = 0; i < density.length; i++) {
			let area = width * height;
			let volume = area * thickness[i + 1];
			let weight = volume * density[i];
			retVal += weight;
		}
	} else if(type === 'duct') {
		for(let i = 0; i < density.length; i++) {
			// let area = ((width+thickness[i+1]*2)*2 + (height+thickness[i+1]*2)*2) *length;
			let area = ( width * 2 + ( height + thickness[i + 1] * 2 ) * 2 ) * length;
			let volume = area * thickness[i + 1];
			let weight = volume * density[i];
			retVal += weight;
		}
	}

	return retVal;
}

export function calculateConcreteHeatloss(props) {
	const {diam, width, length, cThick, type, ambientTemp, mediumTemp} = props;

	console.log('Concrete:', {props});


	let R;
	let A;
	if(type === 'round') {
		R = cThick / CONCRETE_LAMBDA + (Math.PI * diam) / (8 * SOIL_LAMBDA);
		A = Math.PI * Math.pow( (diam / 2), 2);
		// R = ( 4 * cThick ) / ( Math.PI * Math.pow(diam,2) * CONCRETE_LAMBDA ) + ( 1 / ( diam * SOIL_LAMBDA ) )
	} else {
		const sqrAsDiam = Math.sqrt( (width * length) / Math.PI ) * 2;
		R = cThick / CONCRETE_LAMBDA + (2 * (width + length)) / (8 * SOIL_LAMBDA);
		// R = ( 4 * cThick ) / ( Math.PI * Math.pow(sqrAsDiam,2) * CONCRETE_LAMBDA ) + ( 1 / ( sqrAsDiam * SOIL_LAMBDA ) )
		A = width * length;
	}
	const Q = ( ( mediumTemp - ambientTemp ) / R ) * A;
	// const Q = ( 1 / R ) * ( mediumTemp - ambientTemp )

	return Q;
}

export function calculateSoilHeatloss(props) {
	const {diam, width, length, type, ambientTemp, mediumTemp} = props;
	// console.log({props})
	let R;
	let A;
	if(type === 'round') {
		R = (Math.PI * diam) / (8 * SOIL_LAMBDA);
		A = Math.PI * Math.pow( (diam / 2), 2);
		// R = ( 4 * cThick ) / ( Math.PI * Math.pow(diam,2) * CONCRETE_LAMBDA ) + ( 1 / ( diam * SOIL_LAMBDA ) )
	} else {
		const sqrAsDiam = Math.sqrt( (width * length) / Math.PI ) * 2;
		R = (2 * (width + length)) / (8 * SOIL_LAMBDA);
		// R = ( 4 * cThick ) / ( Math.PI * Math.pow(sqrAsDiam,2) * CONCRETE_LAMBDA ) + ( 1 / ( sqrAsDiam * SOIL_LAMBDA ) )
		A = width * length;
	}
	// let A = Math.PI * Math.pow( (diam/2), 2)

	// let calculationDiameter = diam
	// if(type !== 'round') {
	// 	calculationDiameter = Math.sqrt( (width * length) / Math.PI ) * 2
	// 	A = width * length
	// }
	// const R = (Math.PI * calculationDiameter) / (8* SOIL_LAMBDA)
	const Q = ( ( mediumTemp - ambientTemp ) / R ) * A;


/* 	let calculationDiameter = diam
	if(type !== 'round') {
		calculationDiameter = Math.sqrt( (width * length) / Math.PI ) * 2
	}
	const Q = 2 * SOIL_LAMBDA * calculationDiameter * ( mediumTemp - ambientTemp )

 */	// console.log({Q,calculationDiameter})
	return Q;
}
